export default [
  {
    path: '/collection-equipment',
    name: 'CollectDevice',
    component: resolve => require(['@/views/CollectDevice'], resolve)
  }
]
